import React from "react";

import { Formik, Form, useField } from "formik";
import * as Yup from "yup";

const dateOfBirthSchema = Yup.object().shape({
  dateOfBirth: Yup.date().required("Please enter your date of birth"),
});

export type FormValuesType = {
  dateOfBirth: string;
};

type PropsType = {
  formRef: any;
  onSubmit: (details: FormValuesType) => Promise<void>;
};

export default function RequestDateOfBirthForm({
  formRef,
  onSubmit,
}: PropsType) {
  return (
    <Formik
      initialValues={{
        dateOfBirth: "",
      }}
      innerRef={formRef}
      onSubmit={onSubmit}
      validationSchema={dateOfBirthSchema}
    >
      {(props) => (
        <Form autoComplete="off" data-testid="fetch-details-dob-form">
          <input
            autoFocus
            onChange={props.handleChange}
            type="date"
            name="dateOfBirth"
            data-testid="dateOfBirth"
            id="dateOfBirth"
            className="p-2 w-60 border rounded border-gray-600 block mx-auto"
            value={props.values.dateOfBirth}
          />
          {props.errors.dateOfBirth && props.touched.dateOfBirth ? (
            <div className="mt-2 text-red-500">{props.errors.dateOfBirth}</div>
          ) : null}
        </Form>
      )}
    </Formik>
  );
}
